import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus,
  faChevronRight,
  faChevronDown,
  faMagnifyingGlass,
  faAnglesUp,
  faBookOpen,
  faStar,
  faLayerGroup,
} from '@fortawesome/free-solid-svg-icons';

// Doc library icon - open book (reference material, not work items)
export const DocsIcon = ({ size = 14 }) => (
  <FontAwesomeIcon 
    icon={faBookOpen} 
    style={{ fontSize: size }}
  />
);

// Workspace area icon (campaigns / missions plane)
export const WorkspaceIcon = ({ size = 14 }) => (
  <FontAwesomeIcon
    icon={faLayerGroup}
    style={{ fontSize: size }}
  />
);

export const StarStubIcon = ({ size = 14 }) => (
  <FontAwesomeIcon
    icon={faStar}
    style={{ fontSize: size }}
  />
);

// Plus icon for add buttons
export const PlusIcon = ({ size = 12 }) => (
  <FontAwesomeIcon 
    icon={faPlus} 
    style={{ fontSize: size }}
  />
);

// Chevron for expand/collapse (rotates)
export const ChevronIcon = ({ size = 10, expanded = false }) => (
  <FontAwesomeIcon 
    icon={expanded ? faChevronDown : faChevronRight} 
    style={{ fontSize: size }}
  />
);

// Search icon
export const SearchIcon = ({ size = 12 }) => (
  <FontAwesomeIcon 
    icon={faMagnifyingGlass} 
    style={{ fontSize: size }}
  />
);

// Collapse all (nested trees) — same role as Cursor/VS Code Explorer "Collapse Folders"
export const CollapseAllIcon = ({ size = 12 }) => (
  <FontAwesomeIcon
    icon={faAnglesUp}
    style={{ fontSize: size }}
  />
);
